import type { ReactNode } from 'react';

interface LegalLayoutProps {
  title: string;
  /** Already-localised "last updated" line, e.g. "Last updated: 23 August 2026". */
  updated: string;
  children: ReactNode;
}

/**
 * Shared chrome for the Privacy Policy and Terms pages. These documents are
 * published in English only; the surrounding site chrome stays localised.
 */
export function LegalLayout({ title, updated, children }: LegalLayoutProps) {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <h1>{title}</h1>
        <p className="legal-date">{updated}</p>
      </header>

      <div className="legal-body">{children}</div>

      <style>{`
        .legal-page {
          max-width: 780px;
          margin: 48px auto 80px;
          padding: 0 24px;
          color: #1a1a1a;
        }

        .legal-header {
          padding-bottom: 24px;
          margin-bottom: 32px;
          border-bottom: 2px solid #e0e0e0;
        }

        .legal-header h1 {
          font-size: 36px;
          line-height: 1.2;
          margin: 0 0 8px;
        }

        .legal-date {
          color: #666;
          font-size: 15px;
          margin: 0;
        }

        .legal-body {
          font-size: 16px;
          line-height: 1.7;
        }

        .legal-body h2 {
          font-size: 22px;
          margin: 40px 0 12px;
          line-height: 1.3;
        }

        .legal-body h3 {
          font-size: 17px;
          margin: 28px 0 8px;
        }

        .legal-body p {
          margin: 0 0 16px;
        }

        .legal-body ul {
          margin: 0 0 16px;
          padding-left: 24px;
        }

        .legal-body li {
          margin: 8px 0;
        }

        .legal-body a {
          color: #4285f4;
        }

        .legal-body table {
          width: 100%;
          border-collapse: collapse;
          margin: 0 0 24px;
          font-size: 15px;
        }

        .legal-body th,
        .legal-body td {
          border: 1px solid #e0e0e0;
          padding: 10px 12px;
          text-align: left;
          vertical-align: top;
        }

        .legal-body th {
          background: #f5f5f5;
          font-weight: 600;
        }

        .legal-callout {
          margin: 0 0 24px;
          padding: 16px 20px;
          background: #e3f2fd;
          border-radius: 10px;
        }

        .legal-callout p:last-child {
          margin-bottom: 0;
        }

        @media (max-width: 640px) {
          .legal-header h1 { font-size: 28px; }
          .legal-body { font-size: 15px; }
          .legal-body table { display: block; overflow-x: auto; }
        }
      `}</style>
    </div>
  );
}
